import 'bootstrap/js/src/dropdown'
import '@fancyapps/fancybox'
import Swiper from 'swiper'
import RotatorDelay from './modules/rotatordelay'
import Burger from 'mlmi-library/components/burger/v1/burger'
import { getCookie } from 'mlmi-library/utils/cookies'
import Menu from './modules/menu'

$(document).ready(function (){

	// Global variables
	$.website = {
		objects: {},
	}

	// Navigation
	var navigation =
	{
		/*
		*	Properties
		*/
		currentURL : undefined,
		isPopping : false,
		useTransition : false,
		isTouch : false,
		isMobile : false,

		/*
		*	Check mobile
		*/
		checkMobile : function()
		{
			var mobileElement = $('button.burger')
			if (!navigation.isMobile && mobileElement.is(":visible")){
				navigation.isMobile = true
			} else if (navigation.isMobile && !mobileElement.is(":visible")){
				navigation.isMobile = false
				if ($.website.objects.burger.isExpanded) {
					mobileElement.click()
				}
			}
		},

		/*
		*	Page exit
		*/
		pageExit : function()
		{
			// Unload images
			$("#page-content img").attr("src", "").remove()

			// Scroll to top
			$("html, body").scrollTop(0)
		},

		/*
		*	Page display
		*/
		pageDisplay : function(loaded_url, loaded_content)
		{
			// Display loaded page
			var response = $('<html>').html(loaded_content)
			$("#page-content").replaceWith($("#page-content", response))
			setTimeout(function(){
				if (loaded_url == navigation.currentURL){
					navigation.pageLoad()
				}
			}, 50)

			// Remove transition
			setTimeout(function(){
				$("div#page-transition").addClass("hidden").on(TRANSITION_END, function(){
					$("div#page-transition").off(TRANSITION_END).removeClass("visible hidden")
				})
			}, 	150)

			// Push state
			if (!navigation.isPopping){
				document.title = $("title", response).text()
				var data = {
					is_page_transition: true,
					previous_page_url: window.location.href
				}
				window.history.pushState(data, $("title", response).text(), navigation.currentURL)
			}
			navigation.isPopping = false
		},

		/*
		*	Page transition
		*/
		pageTransition : function(href)
		{
			// Keep current URL
			navigation.currentURL = href

			// Setting variables
			var loaded_url = href,
			loaded_content = undefined,
			page_disappeared = false,
			content_loaded = false

			// Show page transition
			$("div#page-transition").addClass("visible").on(TRANSITION_END, function(){
				$(this).off(TRANSITION_END)
				navigation.pageExit()
				page_disappeared = true
				if (content_loaded){
					navigation.pageDisplay(loaded_url, loaded_content)
				}
				$.get(loaded_url, {}, function(x){
					loaded_content = x
					content_loaded = true
					if (page_disappeared){
						navigation.pageDisplay(loaded_url, loaded_content)
					}
				}, 'html')
			})
		},

		/*
		*	Page load
		*/
		pageLoad : function()
		{
			/*
			*	Scroll to top
			*/
			$('#return-to-top').click(function() {
				$('body,html').animate({
					scrollTop : 0
				}, 500)
			})

			/*
			*	Cookie
			*/
			let cookieValues = getCookie('initialTrafficSource')
			if (cookieValues) {
				function extractCookieValues(str) {
					const keyValuePairs = str.split('|');
					const values = {};
					keyValuePairs.forEach(pair => {
						const [key, value] = pair.split('=');
						values[key] = value.replace(/\(|\)/g, '');
					});
					return values;
				}
				function addUtmParameters(url, utmSource, utmMedium, utmCampaign) {
					if (url.includes('?')) {
						return url;
					}
					return `${url}?utm_source=${encodeURIComponent(utmSource)}&utm_medium=${encodeURIComponent(utmMedium)}&utm_campaign=${encodeURIComponent(utmCampaign)}`;
				}
				const { utmcsr, utmcmd, utmccn } = extractCookieValues(cookieValues);
				$('a[href*="/fr/obtenir-soumission-rapide"]').each(function() {
					$(this).attr('href', addUtmParameters($(this).attr('href'), utmcsr, utmcmd, utmccn))
				})
			}

			/*
			*	Burger
			*/
			$.website.objects.burger = new Burger('.burger', {
		    onToggle: function() {
		      if ($.website.objects.burger.isExpanded) {
		        $('body').addClass('menu-open')
		      } else {
		        $('body').removeClass('menu-open')
		      }
		    },
		  })

			/*
			*	Menu behavior
			*/
			$.website.objects.menu = Menu.init()

			/*
			*	Scroll down to section
			*/
			$('a[href^="#section-"]').on('click', function(){
				let anchorName = $(this).attr('href').replace('#', ''),
				targetTop = $('a[name="' + anchorName + '"]').offset().top - $('header').outerHeight(false) - 20,
				distance = Math.abs(targetTop - $("body").scrollTop())
				$("html,body").animate({'scrollTop' : targetTop}, 500 + distance / 5, "swing")
				return false
			})

			/*
			*	Photo gallery slider
			*/
			$(".gallery-slider.swiper-container").each(function(){
				if ($(this).find(".swiper-slide").length > 1){
					$(this).addClass("gallery-slider--active")
					var gallerySlider = new Swiper ($(this).get(0), {
						loop: true,
						speed: 500,
						threshold: 15,
						resistanceRatio: 0.25,
						autoplay: {
							delay: 5000,
							disableOnInteraction: false
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						pagination: {
							el: '.gallery-slider.swiper-container .swiper-pagination',
							type: 'bullets',
							clickable: true,
							renderBullet: function (index, className) {
								return '<span class="' + className + '"></span>'
							}
						},
					}),
					galleryDelay = new RotatorDelay(gallerySlider, 5000, 500)
				}
			})

			/*
			*	Rotator sliders
			*/
			if ($(".banner--rotator").length){
				var rotator = new Swiper ('.banner--rotator', {
					loop: true,
					speed: 350,
					autoplay: {
						delay:4000,
						disableOnInteraction: false
					}
				}),
				rotatorDelay = new RotatorDelay(rotator, 4000, 350)
			}

			/*
			*	Large sliders
			*/
			if ($(".banner--large").length){
				var largeBanner = new Swiper ('.banner--large', {
					loop: true,
					speed: 600,
					autoplay: {
						delay:10000,
						disableOnInteraction: false
					},
					simulateTouch: false,
					watchSlidesVisibility: true,
					pagination: {
						el: '.banner--large .swiper-pagination',
						type: 'bullets',
						clickable: true,
						renderBullet: function (index, className) {
							return '<span class="' + className + '"></span>'
						}
					},
				}),
				largeDelay = new RotatorDelay(largeBanner, 10000, 600)
			}

			/*
			*	CTA Fade-in
			*/
			setTimeout(function(){
				$(".banner--cta.banner--ready").addClass("banner--visible")
			}, 500)

			/*
			*	Article gallery
			*/
			$('.gallery figure').each(function(){
				$(this).find("a").attr("data-fancybox", "article-gallery").attr("data-caption", $(this).find("figcaption").text())
				$(this).find("figcaption").remove()
			})
			$('.gallery figure a').fancybox()

			/*
			*	Custom fancybox links
			*/
			$('a.fancybox').fancybox()

			/*
			*	Button controls
			*/
			$(".liquidation button[aria-controls]").each(function(){
				$(this).on("click", function(){
					var originalText = $(this).text()
					var targetID = $(this).attr("aria-controls"),
					target = $("#"+targetID),
					targetHidden = target.attr("aria-hidden")
					if (targetHidden === "true"){
						target.attr("aria-hidden", "false").slideDown()
					} else {
						target.attr("aria-hidden", "true").slideUp()
					}
					$(this).text($(this).data("toggle-text"))
					$(this).data("toggle-text", originalText)
				})
			})

			/*
			* Confirmation page redirect
			*/
			$(document).on('wpcf7mailsent', function() {
				var language = $("html").attr("lang")
				window.location.href = $('input[name="_wpcf7_ty"]').val()
			})
		},

		/*
		*	Initialize
		*/
		init : function()
		{
			/* History API initial state */
			if ("history" in window && navigation.useTransition){
				window.history.replaceState({
					is_page_transition: true,
					previous_page_url: window.location.href
				}, document.title, window.location.href)

				/* History API pop state */
				$(window).on("popstate", function(e){
					var history_data = e.originalEvent.state
					if (history_data != null){
						if (history_data.is_page_transition != null && history_data.is_page_transition == true){
							navigation.isPopping = true
							navigation.pageTransition(e.target.location.href)
						}
					}
				})

				/* History API transition links */
				$(document).on("click", "a", function(e){
					if (e.originalEvent.cmdKey || e.originalEvent.metaKey){ return true }
					if (!navigation.useTransition) return true
					if ($(this).hasClass("no-transition")){ return true }
					if ($(this).hasClass("action")){ return false }
					if ($(this).attr("href").substr(0, 6) === "mailto"){ return true }
					if ($(this).attr("href").substr(0, 4) === "http"){ return true }
					if ($(this).attr("href") === "#"){ return false }
					if ($(this).attr("target") === "_blank"){ return true }
					navigation.pageTransition($(this).attr("href"))
					return false
				})
			}

			/* Check mobile and touch */
			$(window).on("resize orientationchange load", navigation.checkMobile)
			$(window).on("touchstart", function(){
				if (!navigation.isTouch){
					navigation.isTouch = true
				}
			})
			navigation.checkMobile()

			/* First page load */
			navigation.pageLoad()
		}
	}

	/*
	*	Launch site navigation
	*/
	$.website.navigation = navigation
	$.website.navigation.init()
})
